'use client';

import { useEffect } from 'react';
import { last } from 'lodash-es';
import { useViewCount } from '@/hooks/useViewCount';
import { gtmService, createEcommerceItem } from '@/util/gtm-service';
import { EntryMetadata } from '@/types/Metadata/Metadata';
import { getManufacturer } from '@/util/metadata';

export interface EntryViewCountProps {
  entryId: number;
  title: string;
  startPrice: number;
  highestBid: number | null;
  companyName: string;
  categoryId: number;
  categoryName: string;
  parentCategoryId: number | null;
  parentCategoryName: string | null;
  location: string;
  metadata: EntryMetadata | null;
}

export function EntryViewCount({
  entryId,
  title,
  startPrice,
  highestBid,
  companyName,
  categoryId,
  categoryName,
  parentCategoryId,
  parentCategoryName,
  location,
  metadata,
}: EntryViewCountProps) {
  const { increment } = useViewCount(entryId);

  useEffect(() => {
    increment();

    gtmService.recommendedEcommerce.viewItem(
      createEcommerceItem({
        id: entryId.toString(),
        name: title,
        priceWithoutShippingOrTax: highestBid ?? startPrice,
        company: companyName,
        category: { id: categoryId, name: categoryName },
        parentCategory:
          parentCategoryId !== null && parentCategoryName !== null
            ? { id: parentCategoryId, name: parentCategoryName }
            : undefined,
        brand: getManufacturer(metadata),
        location: last(location.split(','))?.trim() ?? '',
      })
    );
  }, [
    increment,
    entryId,
    title,
    highestBid,
    startPrice,
    companyName,
    categoryId,
    categoryName,
    parentCategoryId,
    parentCategoryName,
    metadata,
    location,
  ]);

  return null;
}
